import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { ReimbursedProduct } from '@queries/userInsurance/queries/getInsuranceQuote';

export const setCheckoutOrderData = () => gql`
  mutation SetCheckoutOrderData($params: SetCheckoutOrderDataParams!) {
    setCheckoutOrderData(params: $params) {
      metadata {
        useMekiCredits
        chargeDeliveryCost
        localVendor {
          paymentMethod
          mixPayments
        }
        assistantVendor {
          paymentMethod
        }
        userInfo {
          rut
          name
          email
        }
        sendEmail
        insuranceInfo {
          claimId
          insuranceId
          reimbursedProducts {
            sku
            observation
            unitReimbursement
            unitCopay
            unitDeductible
            coverage
          }
          rut
          totalReimbursement
          totalDeductible
          totalCopay
        }
      }
    }
  }
`;

export type SetCheckoutOrderDataParams = ResolverParams<{
  orderId: number;
  metadata: {
    installments?: number;
    localVendor?: {
      paymentMethod?: 'TRANSFER' | 'CARD_CASH' | 'CARD' | 'CASH';
      mixPayments?: Record<string, number>;
    };
    assistantVendor?: {
      paymentMethod?: 'TRANSFER' | 'CARD';
    };
    userInfo?: {
      rut?: string;
      name?: string;
      email?: string;
    };
    sendEmail?: boolean;
    useMekiCredits?: boolean;
    chargeDeliveryCost?: boolean;
    insuranceInfo?: {
      rut?: string;
      insuranceId?: number;
      claimId?: number;
      totalReimbursement?: number;
      totalDeductible?: number;
      totalCopay?: number;
      reimbursedProducts?: ReimbursedProduct[];
    };
  };
  replace?: boolean;
}>;

export type SetCheckoutOrderDataResponse = {
  updateOrderMetadata: Pick<Order, 'metadata'>;
};
